import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';
import { COLORS } from 'styles/theme/colors';

export default function LoadingPage() {
  return (
    <LoadingPage.Wrapper>
      <Spin size="large" />
    </LoadingPage.Wrapper>
  );
}

LoadingPage.Wrapper = styled.div`
  background-color: ${COLORS.primaryBackground};
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
`;
